import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withStyles } from "material-ui/styles";
import Autosuggest from "react-autosuggest";
import { debounce } from "throttle-debounce";
import { FormControl, FormHelperText } from "material-ui/Form";
import Button from "material-ui/Button";
import {
  styles,
  renderInput,
  renderSuggestion,
  renderSuggestionsContainer,
  getSuggestionValue
} from "../autocompleteHelper";
import { getLocation } from "..//../../../config/api";
import {
  searchItineraire,
  updateDeparture,
  updateDestination,
  displayLoading
} from "../../../../modules/search";
import GeolocationButton from "../GeolocationButton/GeolocationButton";
import destinationIcon from "../../../../icons/destination.svg";
import departureIcon from "../../../../icons/departure.svg";
import "./ItineraryForm.css";

class ItineraryForm extends Component {
  constructor() {
    super();
    this.state = {
      departure: "",
      destination: "",
      error: { departure: false, destination: false },
      errorLabel: { departure: "", destination: "" },
      suggestions: { departure: [], destination: [] },
      currentInputId: "departure"
    };
    this.debounceFetchSuggestionDeparture = debounce(
      250,
      this.handleSuggestionsDepartureFetchRequested
    );
    this.debounceFetchSuggestionDestination = debounce(
      250,
      this.handleSuggestionsDestinationFetchRequested
    );
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.departure.label &&
      nextProps.departure !== this.props.departure
    ) {
      this.setState({ departure: nextProps.departure.label }, () => {
        if (
          nextProps.departure.coordinates &&
          nextProps.destination.coordinates
        ) {
          this.searchItineraire();
        }
      });
    }
    if (
      nextProps.destination.label &&
      nextProps.destination !== this.props.destination
    ) {
      this.setState({ destination: nextProps.destination.label }, () => {
        if (
          nextProps.departure.coordinates &&
          nextProps.destination.coordinates
        ) {
          this.searchItineraire();
        }
      });
    }
  }

  onFocus = e => {
    this.setState({ currentInputId: e.target.id });
  };

  onKeyPress = event => {
    if (event.charCode === 13) {
      this.searchItineraire();
    }
  };

  handleChangeSearch = prop => (event, { newValue }) => {
    if (prop === "departure" && this.props.departure.label)
      this.props.updateDeparture(null, null);
    if (prop === "destination" && this.props.destination.label)
      this.props.updateDestination(null, null);
    this.setState({
      [prop]: newValue.place_name || event.target.value
    });
  };

  searchItineraire = () => {
    const error = { departure: false, destination: false };
    const errorLabel = { departure: "", destination: "" };
    if (this.state.departure !== "" && this.state.destination !== "") {
      const allPromises = [];
      allPromises.push(
        new Promise((resolve, reject) => {
          getLocation(
            this.state.departure,
            this.props.currentCity.boundingbox
          ).then(results => {
            resolve(results);
          });
        })
      );
      allPromises.push(
        new Promise((resolve, reject) => {
          getLocation(
            this.state.destination,
            this.props.currentCity.boundingbox
          ).then(results => {
            resolve(results);
          });
        })
      );
      Promise.all(allPromises).then(
        data => {
          if (data[0] && data[1]) {
            this.setState({
              departure: data[0][0].place_name,
              destination: data[1][0].place_name,
              error,
              errorLabel
            });
            this.props.searchItineraire(
              this.props.departure.label
                ? this.props.departure.coordinates
                : data[0][0].geometry.coordinates,
              this.props.destination.label
                ? this.props.destination.coordinates
                : data[1][0].geometry.coordinates
            );
          } else {
            if (!data[0]) {
              error.departure = true;
              errorLabel.departure =
                "Impossible de trouver le lieu de départ dans la zone autorisée";
            }
            if (!data[1]) {
              error.destination = true;
              errorLabel.destination =
                "Impossible de trouver votre destination dans la zone autorisée";
            }
            this.setState({
              error,
              errorLabel
            });
          }
        },
        reason => {
          console.log(reason);
        }
      );
    } else {
      if (this.state.departure === "") {
        error.departure = true;
        errorLabel.departure = "Veuillez renseigner votre lieu de départ.";
      }
      if (this.state.destination === "") {
        error.destination = true;
        errorLabel.destination = "Veuillez renseigner votre destination.";
      }
      this.setState({ error, errorLabel });
    }
  };

  handleSuggestionsDepartureFetchRequested = ({ value }) => {
    if (value.length > 2) {
      getLocation(value, this.props.currentCity.boundingbox).then(results => {
        if (results) {
          this.setState({
            suggestions: { departure: results.slice(0, 3), destination: [] }
          });
        }
      });
    } else {
      this.setState({
        suggestions: { departure: [], destination: [] }
      });
    }
  };

  handleSuggestionsDepartureClearRequested = () => {
    this.setState({
      suggestions: { departure: [], destination: [] }
    });
  };

  handleSuggestionsDestinationFetchRequested = ({ value }) => {
    if (value.length > 2) {
      getLocation(value, this.props.currentCity.boundingbox).then(results => {
        if (results) {
          this.setState({
            suggestions: { departure: [], destination: results.slice(0, 3) }
          });
        }
      });
    } else {
      this.setState({
        suggestions: { departure: [], destination: [] }
      });
    }
  };

  handleSuggestionsDestinationlearRequested = () => {
    this.setState({
      suggestions: { departure: [], destination: [] }
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <div className="main-content">
        <form autoComplete="off">
          <div className="departure-container">
            {this.props.results.length === 0 && (
              <div className="main-label">Quel est votre lieu de départ ?</div>
            )}
            <FormControl fullWidth>
              <Autosuggest
                highlightFirstSuggestion
                theme={{
                  container: classes.container,
                  suggestionsContainerOpen: classes.suggestionsContainerOpen,
                  suggestionsList: classes.suggestionsList,
                  suggestion: classes.suggestion,
                  input: classes.input
                }}
                renderInputComponent={renderInput}
                suggestions={this.state.suggestions.departure}
                onSuggestionsFetchRequested={
                  this.debounceFetchSuggestionDeparture
                }
                onSuggestionsClearRequested={
                  this.handleSuggestionsDepartureClearRequested
                }
                focusInputOnSuggestionClick={false}
                renderSuggestionsContainer={renderSuggestionsContainer}
                getSuggestionValue={getSuggestionValue}
                renderSuggestion={renderSuggestion}
                onSuggestionSelected={(e, { suggestionValue }) =>
                  this.props.updateDeparture(
                    suggestionValue.place_name,
                    suggestionValue.geometry.coordinates
                  )
                }
                inputProps={{
                  id: "departure",
                  autoFocus: true,
                  classes,
                  value: this.state.departure,
                  onChange: this.handleChangeSearch("departure"),
                  onFocus: this.onFocus,
                  onKeyPress: this.onKeyPress,
                  error: this.state.error.departure,
                  icon: departureIcon
                }}
              />
              {this.state.error.departure && (
                <FormHelperText error={this.state.error.departure}>
                  {this.state.errorLabel.departure}
                </FormHelperText>
              )}
            </FormControl>
            <GeolocationButton
              isVisible={
                this.state.currentInputId === "departure"
                  ? { display: "block" }
                  : { display: "none" }
              }
              displayLoading={this.props.displayLoading}
              updateAdress={this.props.updateDeparture}
              lastUserPosition={this.props.lastUserPosition}
            />
          </div>
          <div className="destination-container">
            {this.props.results.length === 0 && (
              <div className="main-label">Quelle est votre destination ?</div>
            )}
            <FormControl fullWidth>
              <Autosuggest
                highlightFirstSuggestion
                theme={{
                  container: classes.container,
                  suggestionsContainerOpen: classes.suggestionsContainerOpen,
                  suggestionsList: classes.suggestionsList,
                  suggestion: classes.suggestion,
                  input: classes.input
                }}
                renderInputComponent={renderInput}
                suggestions={this.state.suggestions.destination}
                onSuggestionsFetchRequested={
                  this.debounceFetchSuggestionDestination
                }
                onSuggestionsClearRequested={
                  this.handleSuggestionsDestinationlearRequested
                }
                onSuggestionSelected={(e, { suggestionValue }) =>
                  this.props.updateDestination(
                    suggestionValue.place_name,
                    suggestionValue.geometry.coordinates
                  )
                }
                focusInputOnSuggestionClick={false}
                renderSuggestionsContainer={renderSuggestionsContainer}
                getSuggestionValue={getSuggestionValue}
                renderSuggestion={renderSuggestion}
                inputProps={{
                  id: "destination",
                  autoFocus: false,
                  classes,
                  value: this.state.destination,
                  onChange: this.handleChangeSearch("destination"),
                  onFocus: this.onFocus,
                  onKeyPress: this.onKeyPress,
                  error: this.state.error.destination,
                  icon: destinationIcon
                }}
              />
              {this.state.error.destination && (
                <FormHelperText error={this.state.error.destination}>
                  {this.state.errorLabel.destination}
                </FormHelperText>
              )}
            </FormControl>
            <GeolocationButton
              isVisible={
                this.state.currentInputId === "destination"
                  ? { display: "block" }
                  : { display: "none" }
              }
              updateAdress={this.props.updateDestination}
              displayLoading={this.props.displayLoading}
              lastUserPosition={this.props.lastUserPosition}
            />
          </div>
          <div className="action-container">
            <Button
              onClick={() => this.searchItineraire()}
              className={classes.button}
              color="primary"
            >
              Calculer
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

ItineraryForm.propTypes = {
  searchItineraire: PropTypes.func.isRequired,
  departure: PropTypes.shape().isRequired,
  destination: PropTypes.shape().isRequired,
  updateDeparture: PropTypes.func.isRequired,
  updateDestination: PropTypes.func.isRequired,
  displayLoading: PropTypes.func.isRequired,
  results: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      color: PropTypes.string,
      data: PropTypes.arrayOf(
        PropTypes.shape({
          time: PropTypes.number,
          distance: PropTypes.number,
          path: PropTypes.shape().isRequired
        })
      )
    })
  ).isRequired,
  classes: PropTypes.shape({
    button: PropTypes.string
  }).isRequired,
  currentCity: PropTypes.shape({
    boundingbox: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number))
  }).isRequired
};

const mapStateToProps = state => ({
  results: state.search.results,
  currentCity: state.map.city,
  departure: state.search.departure,
  destination: state.search.destination,
  lastUserPosition: state.map.lastUserPosition
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      searchItineraire,
      updateDeparture,
      updateDestination,
      displayLoading
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(ItineraryForm)
);



// WEBPACK FOOTER //
// ./src/containers/MainCard/TabsCard/ItineraryForm/ItineraryForm.jsx